export default "__VITE_ASSET__CIpbnqPP__"